import { Attribute } from '../product-models/views/Attribute';
import { AttributeValue } from '../product-models/views/AttributeValue';
import { Product } from '../product-models/views/Product';

export enum UserDataEnums {
  InitialTransparent = 'InitialTransparent',
  InitialOpacity = 'InitialOpacity',
}

export enum AttributeTypeENUM {
  ModelChange = 'ModelChange',
  MaterialChange = 'MaterialChange',
  NumericChange = 'NumericChange',
  VariationChange = 'VariationChange',
  BaseAttribute = 'BaseAttribute',
  FlipChange = 'FlipChange',
}

export enum CategoryTypeENUM {
  WallProduct = 'WallProduct',
  Product = 'Product',
}

export enum FlippingAxisEnum {
  X = 'X',
  Y = 'Y',
  Z = 'Z',
}

export enum RelationshipTypeENUM {
  AttributeRelationship = 'AttributeRelationship',
  ParentRelationship = 'ParentRelationship',
}

export enum ProdcutRelationshipGroupTypeEnum {
  Preview = 'Preview',
  Child = 'Child',
  FixedChild = 'FixedChild',
  LinkedPreview = 'LinkedPreview',
  ConnectorRelationship = 'ConnectorRelationship',
}

export enum ProductTypeENUM {
  Module = 'Module',
  Attribute = 'Attribute',
  Child = 'Child',
  FixedChild = 'FixedChild',
  Preview = 'Preview',
  PositionalGhost = 'PositionalGhost',
  LinkedPreview = 'LinkedPreview',
  Connector = 'Connector',
}
export interface ProductWithAttributeAndValuePair {
  product: Product;
  attribute: Attribute;
  attributeValue: AttributeValue | undefined;
}

export enum ProductLoadingStageEnum {
  Loading = 'Loading',
  Finished = 'Finished',
}

export enum ProductVisibilityENUM {
  Ghost = 'Ghost',
  Visible = 'Visible',
  Invisible = 'Invisible',
}
export enum ProductSelectionENUM {
  PreSelected = 'PreSelected',
  Selected = 'Selected',
  Unselected = 'Unselected',
}
export enum ProductHighlightednessEnum {
  Highlighted = 'Highlighted',
  Unhighlighted = 'Unhighlighted',
}
export enum ProductPlacementStageEnum {
  PreAdding = 'PreAdding',
  Adding = 'Adding',
  Moving = 'Moving',
  Placed = 'Placed',
  Stopped = 'Stopped', //when product is placed on preview
}

export enum ProductColisionEnum {
  Colided = 'Colided',
  UnColided = 'UnColided',
}

export enum statusEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
}
